'use client';

import { CombineApiCard } from '../types';

import { Button } from '@/shared/components/button';
import { Card } from '@/shared/components/card';

type Props = {
  cards: CombineApiCard[];
};

export const CombineApiDesktopSection = ({ cards }: Props) => {
  return (
    <div className="px-4 max-sm:hidden">
      <div className="flex h-[240px] gap-8">
        {cards.map(
          ({ id, title, description, icon, buttonLabel, buttonHref }) => {
            return (
              <Card key={id}>
                <div className="flex h-full flex-col justify-between p-6">
                  <div>
                    <h4 className="pb-2 text-[24px] leading-[32px] font-medium">
                      {title}
                    </h4>
                    <p className="text-[16px] leading-[24px] font-normal">
                      {description}
                    </p>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex h-12 w-12 items-center justify-center">
                      {icon}
                    </div>
                    {buttonHref && (
                      <Button
                        href={buttonHref}
                        target="_blank"
                        variant="secondary"
                        className="px-6 py-4 text-[16px] leading-[24px] font-normal"
                      >
                        {buttonLabel}
                      </Button>
                    )}
                  </div>
                </div>
              </Card>
            );
          },
        )}
      </div>
    </div>
  );
};
